import { Type } from "class-transformer";
import { DatevRechercheType } from "./DatevRechercheType";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class DatevRechercheResult {
    type: DatevRechercheType;
    title = "";
    data: OrdinaryObject;
    @Type(() => Date)
    date: Date;
    documentNumber = "";
    originalDocumentNumber = "";
    enaioWorkflowId = "";
    amount = 0;
    @Type(() => Date)
    invoiceDate: Date;
    accountNumber = "";
    contraAccountNumber = "";
    id = "";
}
